"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const scale_1 = require("../../utils/scale");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const IC_DOWN_1 = __importDefault(require("../../assets/icons/IC_DOWN"));
const IC_UP_1 = __importDefault(require("../../assets/icons/IC_UP"));
const helpler_1 = require("../../utils/helpler");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const ModalReportNoti = (props) => {
    const { visible, onClose, data, checkArray = 0, handleChecked, onNext, Violation, setViolation, } = props;
    const [indexViolation, setIndexViolation] = (0, react_1.useState)(0);
    const [showModalVioaltion, setShowModalVioaltion] = (0, react_1.useState)(false);
    const [indexType, setIndexType] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        if (!visible) {
            setIndexType(0);
            setIndexViolation(0);
            setShowModalVioaltion(false);
        }
    }, [visible]);
    const ViewViolation = () => {
        return (react_1.default.createElement(react_native_1.View, { style: { marginBottom: (0, scale_1.scale)(15) } },
            react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                    height: (0, scale_1.scale)(40),
                    width: (0, scale_1.scale)(286),
                    borderWidth: (0, scale_1.scale)(1),
                    borderColor: showModalVioaltion ? '#00AEEF' : '#C8C8C8',
                    flexDirection: 'row',
                    marginLeft: (0, scale_1.scale)(24),
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderRadius: (0, scale_1.scale)(3),
                    paddingHorizontal: (0, scale_1.scale)(10),
                }, onPress: () => {
                    if (indexType == 5) {
                        setShowModalVioaltion(!showModalVioaltion);
                    }
                }, activeOpacity: 0.9 },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: [
                        styles.textCheck,
                        { color: indexType != 5 ? '#C8C8C8' : '#292A33' },
                    ] }, Violation[indexViolation].name),
                showModalVioaltion ? react_1.default.createElement(IC_UP_1.default, null) : react_1.default.createElement(IC_DOWN_1.default, null)),
            showModalVioaltion && (react_1.default.createElement(react_native_1.View, { style: {
                    backgroundColor: '#EDEDED',
                    width: (0, scale_1.scale)(286),
                    marginLeft: (0, scale_1.scale)(24),
                    marginTop: (0, scale_1.scale)(8),
                    borderRadius: (0, scale_1.scale)(3)
                } }, [...Violation]?.map((item) => (react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                    height: (0, scale_1.scale)(40),
                    width: (0, scale_1.scale)(286),
                    paddingLeft: (0, scale_1.scale)(15),
                    justifyContent: 'center',
                }, onPress: () => {
                    setIndexViolation(item?.id),
                        setShowModalVioaltion(false),
                        setViolation(item?.id);
                }, key: item?.id },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles.textCheck }, item?.name))))))));
    };
    return (react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: "fade", statusBarTranslucent: true, transparent: true, onRequestClose: onClose, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        }, ...props },
        react_1.default.createElement(react_native_1.Pressable, { onPress: onClose, style: {
                flex: 1,
                backgroundColor: Colors_1.default.textHeaderOpacity60,
                justifyContent: 'center',
                alignItems: 'center',
            } },
            react_1.default.createElement(react_native_1.View, { style: {
                    backgroundColor: '#FEFEFE', width: (0, scale_1.scale)(343),
                    borderRadius: (0, scale_1.scale)(12),
                    overflow: 'hidden',
                } },
                react_1.default.createElement(react_native_1.View, { style: {
                        paddingHorizontal: (0, scale_1.scale)(16),
                        paddingVertical: (0, scale_1.scale)(20),
                        borderBottomColor: '#E0E0E0',
                    } },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.textHeader }, "\u901A\u5831\u306E\u7A2E\u985E\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"),
                    react_1.default.createElement(react_native_1.ScrollView, { style: { height: 319 }, showsVerticalScrollIndicator: false },
                        data &&
                            data.map((item, index) => {
                                const isActive = checkArray == item.id;
                                return (react_1.default.createElement(react_native_1.View, { key: index },
                                    react_1.default.createElement(react_native_1.TouchableOpacity, { key: item.id, style: styles.checkboxContainer, onPress: () => {
                                            handleChecked(item.id), setIndexType(item?.id);
                                        } },
                                        react_1.default.createElement(react_native_1.View, { style: [
                                                styles.circle,
                                                isActive && { borderColor: '#007AFF' },
                                            ] }, isActive && (react_1.default.createElement(react_native_1.View, { style: styles.checkedCircle }))),
                                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles.textCheck }, item.tagName)),
                                    index == 4 && isActive && ViewViolation()));
                            }),
                        react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.textDetail }, "\u4E0D\u9069\u5207\u3068\u3057\u3066\u901A\u5831\u3055\u308C\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u3084\u30E6\u30FC\u30B6\u30FC\u306F\u904B\u55B6\u306E\u30B9\u30BF\u30C3\u30D5\u304C\u78BA\u8A8D\u3057\u3001\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u30AC\u30A4\u30C9\u30E9\u30A4\u30F3\u306B\u9055\u53CD\u3057\u3066\u3044\u306A\u3044\u304B\u3069\u3046\u304B\u5224\u65AD\u3057\u3066\u3044\u307E\u3059\u3002\u6DF1\u523B\u306A\u9055\u53CD\u306E\u5834\u5408\u3084\u9055\u53CD\u304C\u7E70\u308A\u8FD4\u3055\u308C\u305F\u5834\u5408\u306F\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u505C\u6B62\u3055\u308C\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002"))),
                react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', width: '100%' } },
                    react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.btn, onPress: () => {
                            onClose();
                        } },
                        react_1.default.createElement(CustomText_1.default, { style: styles.textBtn }, "\u30AD\u30E3\u30F3\u30BB\u30EB")),
                    react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.btn, 
                        // disabled={indexType == 0 || (indexType == 5 && indexViolation == 0)}
                        onPress: () => {
                            if ((indexType == 5 && indexViolation == 0) || indexType == 0) {
                                return false;
                            }
                            else {
                                onNext();
                            }
                        }, activeOpacity: 1 },
                        react_1.default.createElement(CustomText_1.default, { weight: '600', style: [styles.textBtn, ((indexType == 5 && indexViolation == 0) || indexType == 0) && { color: '#7C7C7C' }] }, "\u6B21\u3078")))))));
};
const styles = react_native_1.StyleSheet.create({
    mainNoti: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colors_1.default.textHeaderOpacity60,
    },
    checkboxContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: (0, scale_1.scale)(16),
    },
    circle: {
        height: (0, scale_1.scale)(19),
        width: (0, scale_1.scale)(19),
        borderRadius: 99,
        marginRight: 10,
        borderWidth: 1,
        borderColor: '#C8C8C8',
        justifyContent: 'center',
        alignItems: 'center'
    },
    checkedCircle: {
        backgroundColor: '#007AFF',
        width: (0, scale_1.scale)(8),
        height: (0, scale_1.scale)(8),
        borderRadius: 99,
        // marginLeft: scale(5),
        // marginTop:scale(5)
    },
    btn: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 1,
        borderColor: '#DDDDDD',
        height: (0, scale_1.scale)(48),
    },
    textBtn: {
        color: '#007AFF',
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        fontWeight: 'bold',
    },
    vBtn: {
        height: (0, scale_1.scale)(62),
        width: '100%',
        borderTopWidth: 1,
        borderTopColor: '#CCCCCC',
        flexDirection: 'row',
    },
    textHeader: {
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        fontWeight: '600',
        color: '#292A33',
        textAlign: 'center',
        marginBottom: (0, scale_1.scale)(16),
    },
    textCheck: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        fontWeight: '300',
        color: '#292A33',
    },
    textDetail: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        fontWeight: '300',
        color: '#7C7C7C',
    },
    err: {
        color: '#FF0000',
        fontSize: (0, scale_1.moderateScale)(13),
        marginBottom: (0, scale_1.scale)(10),
    },
});
exports.default = ModalReportNoti;
